import { render, staticRenderFns } from "./fatFile-update.vue?vue&type=template&id=61de1c15&scoped=true"
import script from "./fatFile-update.vue?vue&type=script&lang=js"
export * from "./fatFile-update.vue?vue&type=script&lang=js"
import style0 from "./fatFile-update.vue?vue&type=style&index=0&id=61de1c15&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61de1c15",
  null
  
)

export default component.exports